import React from 'react';

const CytoscapeContext = React.createContext();

export default CytoscapeContext;
